/**
 * Checks the current displayed baselayer can be displayed at the current scale.
 * returns baselayer.
 */
function checklayer(scale, companyType) {
    if (scale <= 1500) {  return (companyType == 'training') ? "os10k" : "osmm"; }
    if (scale <= 16500) { return "os10k"; }
    if (scale <= 33500) { return "os25k"; }
    if (scale <= 80000) { return "os50k"; }
    return "os250k";
}
    
export default checklayer;

